import React, {useEffect, useState} from "react";
import {deliveriesService, orderDeliveryService, userServices} from "../../../services";
import {Col, Modal, notification, Row, Spin, Popconfirm, Icon, Button, Table, Divider, Descriptions} from "antd";
import moment from "moment";
import '../modals.css';
import {DeliveryOfferInfo} from "../create-delivery-offer";
import ModalSendComment from "../send-comment";
import i18n from '../../../i18n';

function ApprovedBtn({
                       onAgreeOffer,
                       onCancelAgreeOffer,
                       orderDeliveryId,
                       creatorRole,
                       status,
                       setLoading,
                       user,
                       isAnySumApprove,
                       minOrdersToApprove,
                       setNeedUpdateContact,
                       ordersCount,
                       hasAgreed,
                       dateLoading,
                       orderItem,
                       accessToApproveOrders
                     }) {
  const onConfirmApproveOrderDelivery = (e) => {
    onAgreeOffer();
  };

  let buttons = [];

  if (accessToApproveOrders) {
    if (status === 'new' && (!hasAgreed)) {
      buttons.push(
        <Button
          disabled={false}
          htmlType="button" className="btn typical-btn typical-btn-green typical-btn-xs"
          style={{width: '100%'}}
          onClick={onAgreeOffer}>
          {i18n.t('main.buttons.approve')}
        </Button>
      );
    } else if (status === 'refused') {
      buttons.push(
        <div className="info-line--desc red">{i18n.t('modals.modalListOffersDelivery.buttons.refused')}</div>
      );
    } else if (status === 'agreed') {
      buttons.push(
        <div className="info-line--desc green">{i18n.t('modals.modalListOffersDelivery.buttons.agreed')}</div>
      );
      buttons.push(
        <Button
          disabled={false}
          htmlType="button" className="btn typical-btn typical-btn-red typical-btn-xs"
          style={{width: '100%'}}
          onClick={onCancelAgreeOffer}>
          {i18n.t('main.buttons.cancel')}
        </Button>
      );
    }
  }

  return (
    <div style={{textAlign: 'center'}}>
      {buttons}
    </div>
  );

}

function TableHeaders() {
  return (
    <thead>
    <tr>
      <th>{i18n.t('modals.modalListOffersDelivery.table.dateCreated.title')}</th>
      <th>{i18n.t('modals.modalListOffersDelivery.table.carrier.title')}</th>
      <th>{i18n.t('modals.modalListOffersDelivery.table.contactPerson.title')}</th>
      <th>{i18n.t('modals.modalListOffersDelivery.table.phone.title')}</th>
      <th>{i18n.t('modals.modalListOffersDelivery.table.dateUpLoad.title')}</th>
      <th>{i18n.t('modals.modalListOffersDelivery.table.price.title')}</th>
      <th/>
    </tr>
    </thead>
  );
}

function ContentModalListOffers({
                                  setErrorMsg,
                                  ordersData,
                                  deliveryData,
                                  loading,
                                  errorMsg,
                                  setLoading,
                                  setNeedUpdateDeliveryList,
                                  setStopListUpdate,
                                  setIsShow,
                                  setNeedUpdateContact,
                                  isShow,
                                  user
                                }) {
  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }
  if (loading) {
    return (
      <Row gutter={16} className="add-padding-10">
        <Col span={24} style={{textAlign: 'center'}}>
          <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}/>
        </Col>
      </Row>
    );
  }

  const ordersCount = ordersData.OffersCount;
  const hasAgreed = ordersData.HasAgreed;

  const CommentButton = ({orderItem}) => {
    let buttons = [];
    const [showSendComment, setShowSendComment] = useState(false);

    const commentOffer = (comment) => {

      setLoading(true);

      deliveriesService.commentOffer(deliveryData.Id, orderItem.Id, comment)
        .then((response) => {
          notification.success({
            message: i18n.t('components.notification.titles.commentOffer'),
            description: response.message,
          });

          setLoading(false);
          setIsShow(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.commentOffer'),
            description: error,
          });

          setLoading(false);
        });
    };


    if (orderItem.Status === 'new' || orderItem.Status === 'agreed') {
      buttons.push(
        <>
          <Button
            disabled={false}
            htmlType="button" className="btn typical-btn typical-btn-green typical-btn-xs"
            style={{width: '100%'}}
            onClick={() => setShowSendComment(true)}>
            {i18n.t('modals.modalListOffersDelivery.buttons.comment')}
          </Button>
          <ModalSendComment isShow={showSendComment}
                            setIsShow={setShowSendComment}
                            sendMethod={commentOffer}
                            setNeedUpdateList={setNeedUpdateContact}
          />
        </>
      );
    }

    return (
      <div style={{textAlign: 'center'}}>
        {buttons}
      </div>
    );
  };

  const ActionsButtons = ({orderItem}) => {
    const [orderLimit, setOrderLimit] = useState(null);
    const [orderStatus, setOrderStatus] = useState(orderItem.Status);
    const agreeOffer = () => {

      setLoading(true);

      deliveriesService.agreeOffer(deliveryData.Id, orderItem.Id)
        .then((response) => {
          notification.success({
            message: i18n.t('components.notification.titles.agreeOffer'),
            description: response.message,
          });

          setLoading(false);
          setIsShow(false);
          // setNeedUpdateDeliveryList(true);
          // setStopListUpdate(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.agreeOffer'),
            description: error,
          });

          setLoading(false);
        });
    };

    const cancelAgreeOffer = () => {

      setLoading(true);

      deliveriesService.cancelAgreeOffer(deliveryData.Id, orderItem.Id)
        .then((response) => {
          notification.success({
            message: i18n.t('components.notification.titles.cancelAgreeOffer'),
            description: response.message,
          });

          setLoading(false);
          setIsShow(false);
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.cancelAgreeOffer'),
            description: error,
          });

          setLoading(false);
        });
    };

    return (
      <ApprovedBtn
        onAgreeOffer={agreeOffer}
        onCancelAgreeOffer={cancelAgreeOffer}
        orderDeliveryId={orderItem.Id}
        creatorRole={orderItem.CreatorRole}
        setLoading={setOrderStatus}
        setNeedUpdateContact={setNeedUpdateContact}
        status={orderStatus}
        dateLoading={orderItem.Date}
        user={user}
        isAnySumApprove={orderItem.IsAnySumApprove}
        minOrdersToApprove={orderItem.MinOrdersToApprove}
        ordersCount={ordersCount}
        hasAgreed={hasAgreed}
        orderItem={orderItem}
        accessToApproveOrders={ordersData.Permissions.IsAccessToApproveOrders}
      />
    );
  }

  const columns = [
    {
      render: (record) => (
        <div style={{padding: "10px 0"}}>
          <Descriptions size="small"
                        column={{xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1}}
                        layout="vertical"
          >
            <Descriptions.Item
              span="2"
              label={<b>{i18n.t('modals.modalListOffersDelivery.table.carrier.title')}</b>}
            >{(record.Company && record.Company.Contact && record.Company.LegalEntity.Name)
              ? record.Company.LegalEntity.Name
              : '-'}
            </Descriptions.Item>
            <Descriptions.Item
              label={<b>{i18n.t('modals.modalListOffersDelivery.table.contactPerson.title')}</b>}>{(record.Company && record.Company.Contact && record.Company.Contact.Fio)
              ? record.Company.Contact.Fio
              : '-'}
            </Descriptions.Item>
            <Descriptions.Item
              label={<b>{i18n.t('modals.modalListOffersDelivery.table.phone.title')}</b>}>{(record.Company && record.Company.Contact && record.Company.Contact.Phone)
              ? record.Company.Contact.Phone
              : '-'}
            </Descriptions.Item>
            <Descriptions.Item
              label={<b>{i18n.t('modals.modalListOffersDelivery.table.dateCreated.title')}</b>}>{moment(record.DateCreated).format('D.MM.YYYY HH:mm')}</Descriptions.Item>
            <Descriptions.Item
              label={<b>{deliveryData.IsMultimodal ? i18n.t("Дата выхода судна") : i18n.t('modals.modalListOffersDelivery.table.dateUpLoad.title')}</b>}>{moment(record.Date).format('D.MM.YYYY')}</Descriptions.Item>
                        {record.DateDeparture && <Descriptions.Item label={<b>{i18n.t('modals.modalListOffersDelivery.table.dateDeparture.title')}</b>}>{moment(record.DateDeparture).format('D.MM.YYYY')}</Descriptions.Item>}
            <Descriptions.Item label={<b>{i18n.t('modals.modalListOffersDelivery.table.price.title')}</b>}>
              <div className="order-price-block">
                <div>{(record.Price).toLocaleString('ru')}</div>
                <span
                  className="payment-type">{record.paymentType === 'null-payment-type' ? '-' : record.PaymentType}</span>
              </div>
            </Descriptions.Item>
          </Descriptions>
          <ActionsButtons orderItem={record}/>
        </div>
      ),
      className: "desktop-hidden--md"
    },
    {
      title: i18n.t('modals.modalListOffersDelivery.table.dateCreated.title'),
      render: (record) => (
        <React.Fragment>
          {moment(record.DateCreated).format('D.MM.YYYY HH:mm')}
        </React.Fragment>
      ),
      className: "mobile-hidden--md",
      rowSpan: 2,
    },
    {
      title: i18n.t('modals.modalListOffersDelivery.table.carrier.title'),
      render: (record) => (
        <>{(record.Company && record.Company.Contact && record.Company.LegalEntity.Name)
          ? record.Company.LegalEntity.Name
          : '-'}</>
      ),
      className: "mobile-hidden--md"
    },
    {
      title: <>{i18n.t('modals.modalListOffersDelivery.table.contactPerson.title')}/<br/>{i18n.t('modals.modalListOffersDelivery.table.phone.title')}</>,
      render: (record) => (
        <>
          <div>
            {(record.Company && record.Company.Contact && record.Company.Contact.Fio)
              ? record.Company.Contact.Fio
              : '-'}
          </div>
          <div>
            <b>{(record.Company && record.Company.Contact && record.Company.Contact.Phone)
              ? record.Company.Contact.Phone
              : '-'}</b>
          </div>
        </>
      ),
      className: "mobile-hidden--md"
    },
    {
      title: () => {return (deliveryData.IsMultimodal) ? i18n.t('Дата выхода судна') : i18n.t('modals.modalListOffersDelivery.table.dateUpLoad.title')},
      render: (record) => (
        <>
          {moment(record.Date).format('D.MM.YYYY')}
          {record.DateDeparture ? ' / ' + moment(record.DateDeparture).format('D.MM.YYYY'): ''}
        </>
      ),
      className: "mobile-hidden--md"
    },
    {
      title: i18n.t('modals.modalListOffersDelivery.table.price.title'),
      render: (record) => (
        <div className="order-price-block">
          <div>{(record.Price).toLocaleString('ru')}</div>
          <span className="payment-type">{record.paymentType === 'null-payment-type' ? '-' : record.PaymentType}</span>
        </div>
      ),
      className: "mobile-hidden--md"
    },
    {
      render: (record) => <ActionsButtons orderItem={record}/>,
      className: "mobile-hidden--md"
    }
  ];

  return (
    <>
      <DeliveryOfferInfo delivery={deliveryData}/>
      <Table
        columns={columns}
        dataSource={ordersData.Offers}
        defaultExpandAllRows={true}
        expandedRowRender={record => <>
          <Row>
            <Col lg={6} md={24} sm={24} xs={24}>
              <p style={{margin: 0}}>{record.Comment}</p>
            </Col>
            <Col lg={8} md={24} sm={24} xs={24}>
              <p>{record.CostComments.map((comm) => {
                return (
                  <pre>{comm.message}</pre>
                );
              })}
              </p>
            </Col>
            <Col lg={6} md={24} sm={24} xs={24} style={{paddingRight: 10}}>
              <p>{record.ShipperComments.map((comm) => {
                return (
                  <p>{comm.message}</p>
                );
              })}
              </p>
            </Col>
            <Col lg={4} md={24} sm={24} xs={24}>
              <CommentButton orderItem={record}/>
            </Col>
          </Row>
        </>}
        className={"employees-table"}
        rowKey={"id"}
        size="small"
        pagination={{pageSize: 100}}
      />
    </>
  );
}

export default function ModalListOffersDelivery({
                                                  isShow,
                                                  setIsShow,
                                                  deliveryId,
                                                  setNeedUpdateDeliveryList,
                                                  setStopListUpdate,
                                                  delivery
                                                }) {
  const [loading, setLoading] = useState(false);
  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [ordersData, setOrdersData] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const user = userServices.getUser();
  const [needUpdateContact, setNeedUpdateContact] = useState(false);

  useEffect(() => {
    if (isShow && !loadingContentModal) {
      setLoading(true);
      setLoadingContentModal(true);
    }
  }, [isShow]);

  if (loadingContentModal) {
    deliveriesService.getListNewOffersDelivery(deliveryId)
      .then((response) => {
        setLoadingContentModal(false);
        setOrdersData(response);
        setLoading(false);
      })
      .catch((errorMsg) => {
        setErrorMsg(errorMsg);
      })
  }

  useEffect(() => {
    if (needUpdateContact) {
      deliveriesService.getListNewOffersDelivery(deliveryId)
        .then((response) => {
          setLoadingContentModal(false);
          setOrdersData(response);
          setLoading(false);
          setNeedUpdateContact(false)
        })
        .catch((errorMsg) => {
          setErrorMsg(errorMsg);
        })
    }
  }, [needUpdateContact])

  return (
    <Modal
      title={i18n.t('modals.modalListOffersDelivery.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
        // setNeedUpdateDeliveryList(false);
        // setStopListUpdate(false);
      }}
      footer={null}
    >
      <Row>
        <Col span={24}>
          <ContentModalListOffers
            loading={loading}
            errorMsg={errorMsg}
            ordersData={ordersData}
            deliveryData={delivery}
            //setStopListUpdate={setStopListUpdate}
            setLoading={setLoading}
            setNeedUpdateContact={setNeedUpdateContact}
            setErrorMsg={setErrorMsg}
            setIsShow={setIsShow}
            // setNeedUpdateDeliveryList={setNeedUpdateDeliveryList}
            isShow={isShow}
            user={user}
          />
        </Col>
      </Row>
    </Modal>
  );
}
